import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from "@ng-select/ng-select";
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';

@Component({
  selector: 'app-assign-hour-modal',
  styleUrl: './assign-hour.component.scss',
  templateUrl: './assign-hour.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    NgxMaterialTimepickerModule
  ],
})
export class AssignHourModalComponent {
  formData: FormGroup;
  aux_hour: any;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AssignHourModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ) { 
    this.formData = this.fb.group({
      hourStart: ['', [Validators.required]],
      hourEnd: ['', [Validators.required]],
    });
  }

  ngAfterViewInit(): void {
    this.initUpdateForm();
  }

  initUpdateForm(){
    this.formData.setValue({
      hourStart: this.data.hourStart ? this.data.hourStart: null,
      hourEnd: this.data.hourEnd ? this.data.hourEnd : null
    })
  }
  
  save() {
    this.data.hourStart = this.formData.value.hourStart;
    this.data.hourEnd = this.formData.value.hourEnd;

    const dataToSend = Object.entries(this.data)
    .reduce((acc, [key, value]) => {
      if (value !== '' && !(Array.isArray(value) && value.length === 0)) { 
        acc[key] = value;
      }
      return acc;
    }, {});
    this.dialogRef.close(dataToSend);
  }
}
